import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ANG_APIS } from './api.constants';
import { getSupplierTypeName } from './common.utils';
import { DASHBOARD_SUPPLIER } from '../constants/routes.constants';
import APIService from '../Services/APIService'

export default function CreateSupplier() {
  const { type } = useParams();
  const navigate = useNavigate();
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState();
  const [selectedArea, setSelectedArea] = useState();
  const [selectedSubArea, setSelectedSubArea] = useState();
  const [name, setName] = useState();
  const [areas, setAreas] = useState([]);
  const [subAreas, setSubAreas] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [cityError, setCityError] = useState(false);
  const [areaError, setAreaError] = useState(false);
  const [subAreaError, setSubAreaError] = useState(false);
  const [nameError, setNameError] = useState(false);

  const getCities = async () => {
    let result = await APIService.get(ANG_APIS.GET_CITIES)
    if (result.status = 200) setCities(result.cities)
  };

  const getAreas = async (id) => {
    let result = await APIService.get(`${ANG_APIS.GET_AREA}${id}/?type=areas`)
    if (result.status = 200) setAreas(result.cities)
  };

  const getSubAreas = async (id) => {
    let result = await APIService.get(`${ANG_APIS.GET_AREA}${id}/?type=sub_areas`)
    if (result.status = 200) setSubAreas(result.cities)
  };

  useEffect(() => {
    getCities();
  }, []);

  const handleSelectCity = (e) => {
    setSelectedCity(e.target.value);
    getAreas(e.target.value);
  };

  const handleSelectArea = (e) => {
    setSelectedArea(e.target.value);
    getSubAreas(e.target.value);
  };

  const handleSelectSubArea = (e) => {
    setSelectedSubArea(e.target.value);
  };

  const handleInputChange = (e) => {
    setName(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Reset previous errors
    setCityError(false);
    setAreaError(false);
    setSubAreaError(false);
    setNameError(false);

    let hasErrors = false;
    if (!selectedCity) {
      setCityError(true);
      hasErrors = true;
    }
    if (!selectedArea) {
      setAreaError(true);
      hasErrors = true;
    }
    if (!selectedSubArea) {
      setSubAreaError(true);
      hasErrors = true;
    }
    if (!name) {
      setNameError(true);
      hasErrors = true;
    }

    if (!hasErrors) {
      let payload = {
        area_id: selectedArea,
        city_id: selectedCity,
        subarea_id: selectedSubArea,
        supplier_name: name,
        supplier_type: type,
        supplier_type_name: getSupplierTypeName(type),
      };

      let result = await APIService.post(ANG_APIS.CREATE_SUPPLIER, payload)
      if (result.status = 200) navigate(DASHBOARD_SUPPLIER)
    }
  };

  return (
    <>
      <h2 className="heading">Supplier Initial Details ({getSupplierTypeName(type)})</h2>
      <button type="button" className="smallBtn backbtn" onClick={() => navigate(-1)}>
        Back to Dashboard
      </button>
      <div className="createSection">
        <form name="form" className="" role="form" onSubmit={handleSubmit}>
          <label>City</label>
          <select name="city" className="field" onChange={handleSelectCity}>
            <option value="">Select City</option>
            {cities.length > 0 &&
              cities.map((city, key) => {
                return (
                  <option value={city?.id} key={key}>
                    {city?.city_name}
                  </option>
                );
              })}
          </select>
          <span className="error">{cityError && 'Select a City'}</span>
          <label>Area</label>
          <select name="areas" className="field" onChange={handleSelectArea}>
            <option value="">Select Area</option>
            {areas.length > 0 &&
              areas.map((area, key) => {
                return (
                  <option value={area?.id} key={key}>
                    {area?.label}
                  </option>
                );
              })}
          </select>
          <span className="error">{areaError && 'Select an Area'}</span>
          <label>Sub Area</label>
          <select name="subareas" className="field" onChange={handleSelectSubArea}>
            <option value="">Select Sub-Area</option>
            {subAreas.length > 0 &&
              subAreas.map((area, key) => {
                return (
                  <option value={area?.id} key={key}>
                    {area?.subarea_name}
                  </option>
                );
              })}
          </select>
          <span className="error">{subAreaError && 'Select a Sub-Area'}</span>
          <label>Supplier Name</label>
          <input
            type="text"
            name="supplier_name"
            className="field"
            placeholder="Supplier Name"
            onChange={handleInputChange}
          />
          <span className="error">{nameError && 'Enter a Supplier Name'}</span>

          <button
            type="submit"
            className="submit-btn"
            disabled={!selectedArea || !selectedCity || !selectedSubArea || !name || disabled}
          >
            Create & Continue{' '}
          </button>
        </form>
      </div>
    </>
  );
}
